import { conversionRuleStore } from "src/modules/contracts/components/pricesheet/conversion-rule/conversionRuleStore";
import { CommandGetConversionRuleSchema } from "./commands/cmdGetConversionRuleSchema";

export class ConversionRulesService {
  async loadSchema(organizationId: number) {
    if (
      conversionRuleStore.organizationId === organizationId &&
      conversionRuleStore.entities.length > 0
    ) {
      return;
    }

    conversionRuleStore.isLoadingEntities = true;
    conversionRuleStore.organizationId = organizationId;
    conversionRuleStore.entities = [];
    conversionRuleStore.loadError = null;

    try {
      conversionRuleStore.entities = await new CommandGetConversionRuleSchema().run(organizationId);
    } catch (error) {
      console.error("Failed to load conversion rule schema:", error);
      conversionRuleStore.loadError =
        "Couldn't load this organization's fields. Rules can't be edited until the schema loads — try reopening, or check your access.";
    } finally {
      conversionRuleStore.isLoadingEntities = false;
    }
  }
}
